import { render, staticRenderFns } from "./process-active-table.vue?vue&type=template&id=78974658"
import script from "./process-active-table.vue?vue&type=script&lang=js"
export * from "./process-active-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports